import { t } from "i18next";
import { formatCents } from "../utils/currencyFormat";
import styles from "./SalesOverview.module.css";

function MainOverview({
  totalSum,
  monthSum,
  monthItemNumber,
  monthDifference,
}: {
  totalSum: any;
  monthSum: any;
  monthItemNumber: any;
  monthDifference: number;
}) {
  return (
    <div className={styles.mainOverview}>
      <div className={styles.overviewCard}>
        <div>{t("total_income")}</div>
        <div className={styles.overviewStatisticValue}>
          {formatCents(totalSum)}{" "}
        </div>
      </div>
      <div className={styles.overviewCard}>
        <div>{t("income_last_30_days")}</div>
        <div className={styles.overviewStatisticValue}>
          {formatCents(monthSum)}{" "}
        </div>
      </div>

      <div className={styles.overviewCard}>
        <div>{t("sales_last_30_days")}</div>
        <div className={styles.overviewStatisticValue}>{monthItemNumber}</div>
      </div>
      <div className={styles.overviewCard}>
        <div>{t("change_last_period")}</div>
        <div className={styles.periodChangeValue}>
          {monthDifference.toFixed(1)}%
        </div>
      </div>
    </div>
  );
}

export default MainOverview;
